import clsx from 'clsx';
import React from 'react';

function Container({ children, fullWidth }) {
  return <div className={clsx('px-4 lg:px-8', !fullWidth && 'lg:mx-auto lg:max-w-7xl ')}>{children}</div>;
}

export default Container;
